import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NormalFilterItem} from '../../../interface/normal-filter-item';

@Component({
  selector: 'fb-filter-config-sub-content',
  templateUrl: './filter-config-sub-content.component.html',
  styleUrls: ['./filter-config-sub-content.component.scss']
})
export class FilterConfigSubContentComponent {
	@Input() public subControl: NormalFilterItem = {} as NormalFilterItem;
	@Input() public collapse: boolean = true;

	@Output() public onControlChange: EventEmitter<null> = new EventEmitter<null>();

	public collapseSubTree: boolean = true;
	public isAllChecked: boolean = false;

	constructor() {
	}

	public toggleCollapseSubTree() {
		this.collapseSubTree = !this.collapseSubTree;
	}

	public updateAllComplete() {
		this.isAllChecked = (
			this.subControl.subOptions != null &&
			this.subControl.subOptions.every(c => c.activated)
		);
	}

	public someComplete(): boolean {
		if (this.subControl.subOptions == null) return false;

		return (
			this.subControl.subOptions.filter(c => c.activated).length > 0 &&
			!this.isAllChecked
		);
	}

	public setAll(checked: boolean) {
		this.isAllChecked = checked;

		if (this.subControl.subOptions == null) return;

		this.subControl.subOptions.forEach(c => (c.activated = checked));
	}

	public onChange(): void {
		this.onControlChange.emit(null);
	}
}
